import gql from 'graphql-tag';

// # Query to fetch a paginated list of trip boards
//     paginatedTripBoards(
//         # The hav ID associated with this trip board
//         hav: String!
//         # The page being requested
//         page: Int
//         # The number of results requested from each page
//         pageSize: Int
//     ): PaginatedTripBoards
export const fetchPreviewsQuery = gql`
    query paginatedTripBoards($hav: String!, $pageSize: Int!, $listingPageSize: Int) {
        paginatedTripBoards(hav: $hav, pageSize: $pageSize) {
            tripBoards {
                uuid
                name
                stay {
                    adultCount
                    childrenCount
                    petsIncluded
                    dateRange {
                        arrival
                        departure
                    }
                }
                listingRefs
                listings(pageSize: $listingPageSize) {
                    listingId
                    images {
                        c6_uri
                        height
                        width
                    }
                }
            }
        }
    }
`;

// # Add a Unit to the trip board document.
// addUnitToTripBoard(
//     # The hav ID of the user adding the unit
//     hav: String!
//     # The uuid of the trip board.
//     tripBoardUuid: String!
//     # The unitTriad for the listing.
//     unitTriad: String!
// ): Boolean sucess or failure

export const addToTripboardMutation = gql`
    mutation addUnitToTripBoard($hav: String!, $tripBoardUuid: String!, $unitTriad: String!) {
        addUnitToTripBoard(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad)
    }
`;

// # Creates a new trip board document.
// createTripBoard(
//     # The hav ID of the user creating the trip board.
//     hav: String!
//     # The trip board being created.
//     tripBoard: TripBoardInput!
// ): TripBoard

// input TripBoardInput {
//     boardId: String
//     createTime: String
//     dated: Boolean
//     endDate: String
//     listings: [TripBoardListingInput]
//     name: String!
//     shared: Boolean
//     sourceFavorite: Boolean
//     startDate: String
//     updateTime: String
// }

// input TripBoardListingInput {
//     endDate: String
//     listingId: String!
//     startDate: String
// }
export const createNewTripboardMutation = gql`
    mutation createTripBoard($hav: String!, $tripBoard: TripBoardInput!, $listingPageSize: Int) {
        createTripBoard(hav: $hav, tripBoard: $tripBoard) {
            uuid
            name
            listingRefs
            stay {
                adultCount
                childrenCount
                petsIncluded
                dateRange {
                    arrival
                    departure
                }
            }
            listings(pageSize: $listingPageSize) {
                listingId
                images {
                    c6_uri
                    height
                    width
                }
            }
        }
    }
`;

// # Updates the stay (guest context with dates) on the trip board document unit.
// updateStayOnTripBoard(
//     # The hav ID of the user updating the stay.
//     hav: String!
//     # The uuid of the trip board.
//     tripBoardUuid: String!
//     # The guest context with dates.
//     stay: StayInput!
// ): Boolean
export const updateStayMutation = gql`
    mutation updateStayOnTripBoard($hav: String!, $tripBoardUuid: String!, $stay: StayInput!) {
        updateStayOnTripBoard(hav: $hav, tripBoardUuid: $tripBoardUuid, stay: $stay)
    }
`;

// # Removes a Unit from multiple trip board documents.
// removeUnitFromTripBoards(
//     # The hav ID of the user removing the unit.
//     hav: String!
//     # The unitTriad for the listing.
//     unitTriad: String!
// ): Boolean

export const removeUnitFromTripBoardsMutation = gql`
    mutation removeUnitFromTripBoards($hav: String!, $unitTriad: String!) {
        removeUnitFromTripBoards(hav: $hav, unitTriad: $unitTriad)
    }
`;
